import api from '@/lib/api';

import { auth } from '@/lib/firebase';

export const actions = {
  async fetchBestContents(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get('content/best-contents',
        { params: payload, headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async contentProduction(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.post('/content/',
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async fetchContentProductions(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.get('/content/all-production',
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` } 
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async fetchContentProductionsActive(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.get('/content/active',
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` } 
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async fetchContentProductionsProduction(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.get('/content/production',
        { 
          params: payload,
          headers: { Authorization: `Bearer ${token}` } 
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },

  async addContentMessageReview(_, { id, messageReview }) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const response = await api.put(`/content/${id}/message-review`,
        { messageReview },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      throw error;
    }
  },
}

export default {
  namespaced: true,
  actions,
}